/**
 * First dashboard control: keep every card on one row from mid-size up.
 * Cards share the row equally and shrink when the page is resized (about 80%–100%).
 * Below that they wrap two-up so phones stay readable.
 */
const DashboardCardRow = ({ children, className = '' }) => (
  <div
    className={`grid grid-cols-2 lg:grid-cols-none lg:grid-flow-col lg:auto-cols-fr gap-2 sm:gap-3 mb-4 sm:mb-6 items-stretch [&>*]:min-w-0 ${className}`}
  >
    {children}
  </div>
);

export default DashboardCardRow;
